import { useEffect } from 'react';
import Swal from 'sweetalert2';
import type { SweetAlertIcon } from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const seletorFeedback = '.msg-erro, .msg-ok';
const mensagensPorElemento = new WeakMap<Element, string>();
const mensagensRecentes = new Map<string, number>();

function iconDoElemento(elemento: Element): SweetAlertIcon {
  return elemento.classList.contains('msg-erro') ? 'error' : 'success';
}

function mostrarFeedback(elemento: Element) {
  if (elemento.closest('.swal2-container')) return;
  const texto = (elemento.textContent || '').trim();
  if (!texto) return;

  const icon = iconDoElemento(elemento);
  const chaveElemento = `${icon}:${texto}`;
  if (mensagensPorElemento.get(elemento) === chaveElemento) return;
  mensagensPorElemento.set(elemento, chaveElemento);

  const agora = Date.now();
  const chaveRecente = `${icon}:${texto}`;
  if (agora - (mensagensRecentes.get(chaveRecente) || 0) < 1500) return;
  mensagensRecentes.set(chaveRecente, agora);

  Swal.fire({
    toast: true,
    position: 'bottom-end',
    icon,
    iconColor: icon === 'error' ? '#dc2626' : '#16a34a',
    title: texto,
    showConfirmButton: false,
    timer: icon === 'error' ? 5200 : 3200,
    timerProgressBar: true,
    background: '#fff',
    color: '#0f1b34',
    customClass: { popup: 'manux-toast', timerProgressBar: 'manux-toast-progress' },
  });
}

function escanearFeedbacks(raiz: ParentNode) {
  if (raiz instanceof Element && raiz.matches(seletorFeedback)) {
    mostrarFeedback(raiz);
  }
  raiz.querySelectorAll?.(seletorFeedback).forEach(mostrarFeedback);
}

export default function FeedbackAlerts() {
  useEffect(() => {
    const processar = () => escanearFeedbacks(document.body);
    processar();

    const observer = new MutationObserver((mutacoes) => {
      for (const mutacao of mutacoes) {
        if (mutacao.type === 'characterData') {
          const pai = mutacao.target.parentElement;
          if (pai) escanearFeedbacks(pai);
          continue;
        }

        if (mutacao.target instanceof Element) {
          escanearFeedbacks(mutacao.target);
        }
        mutacao.addedNodes.forEach((node) => {
          if (node instanceof Element) escanearFeedbacks(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
